import { useMemo } from "react";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";

export function createLinkProps(link: Link) {
  return {
    href: link.url,
    "aria-label": link.ariaLabel,
    target: link.external ? "_blank" : undefined,
    rel: link.external ? "noopener noreferrer" : undefined,
  };
}

export function useLinkProps(link?: Link) {
  return useMemo(() => (link ? createLinkProps(link) : null), [link]);
}
